import script from "./comment-entries.vue?vue&type=script&setup=true&lang=js"
export * from "./comment-entries.vue?vue&type=script&setup=true&lang=js"

import "./comment-entries.vue?vue&type=style&index=0&id=6c169a34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c169a34"]])

export default __exports__